import {
  SEND_ACTIVATION_EMAIL,
  SENT_ACTIVATION_EMAIL,
  SET_STEP,
  SET_USER_ID
} from 'src/app/redux/actions/registration/registration';


const initialState = {
  step: '',
  sendingActivationEmail: false,
  userId: 0
};

const registrationReducer = (state = initialState, action) => ({
  [SET_STEP]: () => ({ ...state, ...action.payload }),
  [SEND_ACTIVATION_EMAIL]: () => ({ ...state, sendingActivationEmail: true }),
  [SENT_ACTIVATION_EMAIL]: () => ({ ...state, sendingActivationEmail: false }),
  [SET_USER_ID]: () => ({ ...state, ...action.payload })
}[action.type] || (() => state))();

export default registrationReducer;
